module.exports = __webpack_public_path__ + "static/media/SDT-G2-Residential.f976b3c3.png";